.toolsContainer {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 8px;
}
.toolsContainer .postpone {
  flex: 1 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
}
.toolsContainer .postpone .buttons :first-child {
  margin-bottom: 4px;
}
.toolsContainer .postpone .buttons {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-evenly;
}
.toolsContainer .origins {
  flex: 1 auto;
  margin-left: 8px;
  display: flex;
  flex-flow: row wrap;
}
.toolsContainer .origins .content {
  display: flex;
  flex-flow: column nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1eUZvcm0uc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVFO0VBQ0U7O0FBRko7RUFHRTtFQUNBO0VBQ0E7O0FBQ0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIudG9vbHNDb250YWluZXJcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWZsb3c6IHJvdyB3cmFwXG4gIG1hcmdpbi1ib3R0b206IDhweFxuICAucG9zdHBvbmVcbiAgICBmbGV4OiAxIGF1dG9cbiAgICBkaXNwbGF5OiBmbGV4XG4gICAgZmxleC1mbG93OiByb3cgbm93cmFwXG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1ldmVubHlcbiAgICAuYnV0dG9uc1xuICAgICAgOmZpcnN0LWNoaWxkXG4gICAgICAgIG1hcmdpbi1ib3R0b206IDRweFxuICAgICAgZGlzcGxheTogZmxleFxuICAgICAgZmxleC1mbG93OiBjb2x1bW4gbm93cmFwXG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWV2ZW5seVxuICAub3JpZ2luc1xuICAgIGZsZXg6IDEgYXV0b1xuICAgIG1hcmdpbi1sZWZ0OiA4cHhcbiAgICBkaXNwbGF5OiBmbGV4XG4gICAgZmxleC1mbG93OiByb3cgd3JhcFxuICAgIC5jb250ZW50XG4gICAgICBkaXNwbGF5OiBmbGV4XG4gICAgICBmbGV4LWZsb3c6IGNvbHVtbiBub3dyYXBcbiJdfQ== */